<template>
	<div style="width: 100%;">
		<div
			style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
			{{selectdItem.compontChildren[0].name + '设置'}}
		</div>
		<div style="padding-bottom: 10px;" v-for="(imgItem,imgIndex) in selectdItem.compontChildren[0].data.img.list"
			:key="imgIndex">
			<div style="margin-left: 20px;padding-top: 10px;">图片{{imgIndex + 1}}
			</div>
			<div style="display: flex;justify-content: center;">
				<div style="display: flex;align-items: center;height: 72px;width: 210px;justify-content: space-around;">
					<div @click="dialogVisibleImgs = true;imgsIndex = imgIndex"
						style="height: 60px;width: 120px;background-color: #fff;display: flex;align-items: center;justify-content: center;cursor: pointer;">
						<el-image fit="contain" style="width: 100%;height: 100%;" :src="imgItem.url">
							<div slot="error" class="image-slot"
								style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">
								<i style="font-weight: bold;font-size: 22px;" class="el-icon-plus"></i>
							</div>
						</el-image>
					</div>
					<div @click="deleteImgs(imgIndex);"
						v-if="imgIndex != 0 && imgIndex != selectdItem.compontChildren[0].data.img.list.length - 1"
						style="color: #8c62ff;cursor: pointer;font-weight: bold;">删除
					</div>
				</div>
			</div>
			
			<div class="item">
				<div style="width: 100px;">标题内容</div>
				<el-input v-model="imgItem.tit1" style="margin-left: 10px;" size="mini" placeholder="请输入内容"></el-input>
			</div>

			<div class="item">
				<div style="width: 100px;">副标题内容</div>
				<el-input v-model="imgItem.tit2" style="margin-left: 10px;" size="mini" placeholder="请输入内容"></el-input>
			</div>
			<select-page :link="imgItem.link" @confirmSelect="($event)=>{imgItem.link = $event}"></select-page>

		</div>

		<div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
		</div>

		<div class="item">
			<div>{{equipment == 'pc'?'pc端':'移动端'}}每行个数</div>
			<div>
				<wm-input-number
					:value="equipment == 'pc'?this.selectdItem.compontChildren[0].layoutConfig.img.pcNum:this.selectdItem.compontChildren[0].layoutConfig.img.phoneNum"
					:disabled="false" style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}"
					:step="1" :min="1" :max="20" @change="changeValue($event)"></wm-input-number>
			</div>
		</div>
		<div class="item" v-if="equipment == 'pc'">
			<div>行边距</div>
			<div>
				<wm-input-number :value="selectdItem.compontChildren[0].layoutConfig.img.rowGap" :disabled="false"
					style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}" :step="1" :min="1"
					:max="100"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.img.rowGap = e}"></wm-input-number>
			</div>
		</div>
		<div class="item" v-if="equipment == 'pc'">
			<div>列边距</div>
			<div>
				<wm-input-number :value="selectdItem.compontChildren[0].layoutConfig.img.columnGap" :disabled="false"
					style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}" :step="1" :min="1"
					:max="100"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.img.columnGap = e}"></wm-input-number>
			</div>
		</div>

		<div class="item" v-if="equipment == 'phone'">
			<div>行边距</div>
			<div>
				<wm-input-number :value="selectdItem.compontChildren[0].layoutConfig.img.phoneRowGap" :disabled="false"
					style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}" :step="1" :min="1"
					:max="100"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.img.phoneRowGap = e}"></wm-input-number>
			</div>
		</div>
		<div class="item" v-if="equipment == 'phone'">
			<div>列边距</div>
			<div>
				<wm-input-number :value="selectdItem.compontChildren[0].layoutConfig.img.phoneColumnGap"
					:disabled="false" style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}"
					:step="1" :min="1" :max="100"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.img.phoneColumnGap = e}"></wm-input-number>
			</div>
		</div>
		
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">排版模式</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.typesetting = 'default'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.typesetting == 'default'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.typesetting == 'default'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.typesetting == 'default'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 56px;text-align: center;">
					<span style="scale: 0.85;">默认</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.typesetting = 'lr'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.typesetting== 'lr'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.typesetting== 'lr'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.typesetting== 'lr'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 56px;text-align: center;">
					<span style="scale: 0.85;">左右</span>
				</div>
			</div>
		</div>
		
		<div v-if="equipment == 'pc'" style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">悬停放大</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.isScale = 'yes'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.isScale == 'yes'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.isScale == 'yes'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.isScale == 'yes'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 56px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.isScale = 'no'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.isScale == 'no'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.isScale == 'no'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.isScale == 'no'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 56px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">显示模式</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.mode = 'cover'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.mode == 'cover'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.mode == 'cover'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.mode == 'cover'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 56px;text-align: center;">
					<span style="scale: 0.85;">裁剪填充</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.mode = 'contain'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.mode== 'contain'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.mode== 'contain'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.mode== 'contain'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 56px;text-align: center;">
					<span style="scale: 0.85;">原图填充</span>
				</div>
			</div>
		</div>

		<div class="item">
			<div>图片宽度</div>
			<div>
				<wm-input-number
					:value="equipment == 'pc'?selectdItem.compontChildren[0].layoutConfig.img.width : selectdItem.compontChildren[0].layoutConfig.img.phoneWidth"
					:disabled="false" style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}"
					:step="1" :min="1" :max="100000000000000000000"
					@change="(e)=>{equipment == 'pc'?selectdItem.compontChildren[0].layoutConfig.img.width = e : selectdItem.compontChildren[0].layoutConfig.img.phoneWidth = e}"></wm-input-number>
			</div>
		</div>
		<div class="item">
			<div>图片高度</div>
			<div>
				<wm-input-number
					:value="equipment == 'pc'?selectdItem.compontChildren[0].layoutConfig.img.height : selectdItem.compontChildren[0].layoutConfig.img.phoneHeight "
					:disabled="false" style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}"
					:step="1" :min="1" :max="100000000000000000000"
					@change="(e)=>{equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.img.height = e : selectdItem.compontChildren[0].layoutConfig.img.phoneHeight = e}"></wm-input-number>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">悬停边框颜色</div>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.img.hoverShadowColor"
				style="margin-left: 3px;"></el-color-picker>
		</div>
		<div class="item">
			<div>背景设置</div>
			<div style="display: flex;align-items: center;margin-left:8px;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.bg.type = '1'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.bg.type == '1'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.bg.type == '1'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.bg.type == '1'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">纯色</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.bg.type = '2'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.bg.type == '2'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.bg.type == '2'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.bg.type == '2'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">渐变</span>
				</div>
			</div>
		</div>

		<div class="item" v-if="selectdItem.compontChildren[0].layoutConfig.img.bg.type == '1'">
			<div style="width: 68px;">
				背景颜色:
			</div>
			<el-color-picker size="mini"
				v-model="selectdItem.compontChildren[0].layoutConfig.img.bg.color"></el-color-picker>
		</div>

		<div class="item" v-if="selectdItem.compontChildren[0].layoutConfig.img.bg.type == '2'">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.img.bg.type == '2'"
				style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
				<div
					style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
					<div style="display: flex;flex-direction: column;">
						<div style="display: flex;align-items: center;">
						</div>
						<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3" placeholder="请输入内容"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.bg.gradientColor">
						</el-input>
					</div>
					<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
						需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
							href="https://www.eggradients.com/">Gradient1</a> <a style="margin-left: 4px;"
							target="_blank" href="https://webgradients.com/">Gradient2</a>
					</div>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">组件边框</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.border.type = ''"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.border.type == ''?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.border.type == ''?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">无</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.border.type = 'solid'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.border.type == 'solid'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.border.type == 'solid'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.border.type== 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">实线</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.border.type = 'dashed'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.border.type == 'dashed'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.border.type == 'dashed'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">虚线</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">边框颜色</div>
			<el-color-picker size="mini" style="height: 34px;width: 34px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.img.border.color"></el-color-picker>
			<el-input size="mini" style="height: 34px;width: 82px;" disabled
				:value="selectdItem.compontChildren[0].layoutConfig.img.border.color"></el-input>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.img.border.borderSize" style="margin-top: 10px;">
				<div>线条大小</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.border.borderSize[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.border.borderSize[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.border.borderSize[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.border.borderSize[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerSizeAll = !borderContainerSizeAll"
							:style="{color:borderContainerSizeAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div style="margin-top: 10px;" v-if="selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius">
				<div>边框圆角</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左上</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右上</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top:2px;">右下</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左下</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerRadiusAll = !borderContainerRadiusAll"
							:style="{color:borderContainerRadiusAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.img.padding" style="margin-top: 10px;">
				<div>内边距</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSet" v-model="selectdItem.compontChildren[0].layoutConfig.img.padding[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSet" v-model="selectdItem.compontChildren[0].layoutConfig.img.padding[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSet" v-model="selectdItem.compontChildren[0].layoutConfig.img.padding[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSet" v-model="selectdItem.compontChildren[0].layoutConfig.img.padding[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="paddingAll = !paddingAll" :style="{color:paddingAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		
		<div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
		</div>
		
		<div style="margin-left: 6px;margin-top: 10px;">主标题设置</div>
		
		<div class="item" v-if="selectdItem.compontChildren[0].layoutConfig.img.typesetting == 'default'">
			<div style="width: 80px;">标题位置</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1InImg = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1InImg?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1InImg?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1InImg?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">图上</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1InImg = false"
					:style="{backgroundColor:!selectdItem.compontChildren[0].layoutConfig.img.tit.tit1InImg?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.img.tit.tit1InImg?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.img.tit.tit1InImg?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">置下</span>
				</div>
			</div>
		</div>
		<div v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1InImg && selectdItem.compontChildren[0].layoutConfig.img.typesetting == 'default'" style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position = 'center'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position == 'center'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position == 'center'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position == 'center'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">中</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position  = 'top'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position  == 'top'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position  == 'top'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position  == 'top'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">上</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position = 'bottom'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position == 'bottom'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position == 'bottom'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position == 'bottom'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">下</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position = 'left'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position == 'left'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position == 'left'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position == 'left'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">左</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position = 'right'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position == 'right'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position == 'right'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Position == 'right'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">右</span>
				</div>
			</div>
		</div>
		
		<div class="item">
			<el-select size="mini" style="width: 100px;" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Family" placeholder="选择字体">
				<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
					:value="fontItem.name">
				</el-option>
			</el-select>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Color" style="margin-left: 3px;"></el-color-picker>
		
			<div
				style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Size" @change="(e)=>{selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Size = e}"></wm-input-number>
			</div>
		</div>
		<div class="item">
			<div>悬停颜色</div>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1HoverColor"
				style="margin-left: 3px;"></el-color-picker>
		</div>
		
		<div class="item">
			<div>背景设置</div>
			<div style="display: flex;align-items: center;margin-left:8px;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.type = '1'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.type == '1'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.type == '1'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.type == '1'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">纯色</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.type = '2'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.type == '2'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.type == '2'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.type == '2'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">渐变</span>
				</div>
			</div>
		</div>
		
		<div class="item" v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.type == '1'">
			<div style="width: 68px;">
				背景颜色:
			</div>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.color"></el-color-picker>
		</div>
		
		<div class="item" v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.type == '2'">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.type == '2'"
				style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
				<div
					style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
					<div style="display: flex;flex-direction: column;">
						<div style="display: flex;align-items: center;">
						</div>
						<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
							placeholder="请输入内容" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Bg.gradientColor">
						</el-input>
					</div>
					<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
						需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
							href="https://www.eggradients.com/">Gradient1</a> <a style="margin-left: 4px;"
							target="_blank" href="https://webgradients.com/">Gradient2</a>
					</div>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Padding" style="margin-top: 10px;">
				<div>内边距</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSetTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Padding[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSetTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Padding[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSetTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Padding[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSetTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Padding[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="paddingAllTit1 = !paddingAllTit1"
							:style="{color:paddingAllTit1?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Margin" style="margin-top: 10px;">
				<div>外边距</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="marginSetTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Margin[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="marginSetTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Margin[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="marginSetTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Margin[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="marginSetTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Margin[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="marginAllTit1 = !marginAllTit1" :style="{color:marginAllTit1?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">组件边框</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.type = ''"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.type == ''?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.type == ''?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">无</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.type = 'solid'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.type == 'solid'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.type == 'solid'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.type== 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">实线</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.type = 'dashed'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.type == 'dashed'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.type == 'dashed'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">虚线</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">边框颜色</div>
			<el-color-picker size="mini" style="height: 34px;width: 34px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.color"></el-color-picker>
			<el-input size="mini" style="height: 34px;width: 82px;" disabled
				:value="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.color"></el-input>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.borderSize" style="margin-top: 10px;">
				<div>线条大小</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSizeTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.borderSize[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSizeTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.borderSize[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSizeTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.borderSize[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSizeTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.borderSize[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerSizeAllTit1 = !borderContainerSizeAllTit1"
							:style="{color:borderContainerSizeAllTit1?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div style="margin-top: 10px;" v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.borderRadius">
				<div>边框圆角</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadiusTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.borderRadius[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左上</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadiusTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.borderRadius[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右上</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadiusTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.borderRadius[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top:2px;">右下</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadiusTit1($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Border.borderRadius[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左下</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerRadiusAllTit1 = !borderContainerRadiusAllTit1"
							:style="{color:borderContainerRadiusAllTit1?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		<div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
		</div>
		
		<div style="margin-left: 6px;margin-top: 10px;">副标题设置</div>
		
		<div class="item" v-if="selectdItem.compontChildren[0].layoutConfig.img.typesetting == 'default'">
			<div style="width: 80px;">标题位置</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2InImg = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2InImg?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2InImg?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2InImg?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">图上</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2InImg = false"
					:style="{backgroundColor:!selectdItem.compontChildren[0].layoutConfig.img.tit.tit2InImg?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.img.tit.tit2InImg?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.img.tit.tit2InImg?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">置下</span>
				</div>
			</div>
		</div>
		
		<div v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2InImg && selectdItem.compontChildren[0].layoutConfig.img.typesetting == 'default'" style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position = 'center'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position == 'center'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position == 'center'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position == 'center'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">中</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position  = 'top'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position  == 'top'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position  == 'top'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position  == 'top'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">上</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position = 'bottom'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position == 'bottom'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position == 'bottom'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position == 'bottom'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">下</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position = 'left'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position == 'left'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position == 'left'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position == 'left'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">左</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position = 'right'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position == 'right'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position == 'right'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Position == 'right'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">右</span>
				</div>
			</div>
		</div>
		
		<div class="item">
			<el-select size="mini" style="width: 100px;" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Family" placeholder="选择字体">
				<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
					:value="fontItem.name">
				</el-option>
			</el-select>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Color" style="margin-left: 3px;"></el-color-picker>
		
			<div
				style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Size" @change="(e)=>{selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Size = e}"></wm-input-number>
			</div>
		</div>
		
		<div class="item">
			<div>悬停颜色</div>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2HoverColor"
				style="margin-left: 3px;"></el-color-picker>
		</div>
		
		<div class="item">
			<div>背景设置</div>
			<div style="display: flex;align-items: center;margin-left:8px;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.type = '1'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.type == '1'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.type == '1'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.type == '1'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">纯色</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.type = '2'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.type == '2'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.type == '2'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.type == '2'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">渐变</span>
				</div>
			</div>
		</div>
		
		<div class="item" v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.type == '1'">
			<div style="width: 68px;">
				背景颜色:
			</div>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.color"></el-color-picker>
		</div>
		
		<div class="item" v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.type == '2'">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.type == '2'"
				style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
				<div
					style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
					<div style="display: flex;flex-direction: column;">
						<div style="display: flex;align-items: center;">
						</div>
						<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
							placeholder="请输入内容" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Bg.gradientColor">
						</el-input>
					</div>
					<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
						需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
							href="https://www.eggradients.com/">Gradient1</a> <a style="margin-left: 4px;"
							target="_blank" href="https://webgradients.com/">Gradient2</a>
					</div>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Padding" style="margin-top: 10px;">
				<div>内边距</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSetTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Padding[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSetTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Padding[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSetTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Padding[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSetTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Padding[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="paddingAllTit2 = !paddingAllTit2"
							:style="{color:paddingAllTit2?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Margin" style="margin-top: 10px;">
				<div>外边距</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="marginSetTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Margin[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="marginSetTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Margin[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="marginSetTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Margin[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="marginSetTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit)" v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Margin[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="marginAllTit2 = !marginAllTit2" :style="{color:marginAllTit2?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">组件边框</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.type = ''"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.type == ''?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.type == ''?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">无</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.type = 'solid'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.type == 'solid'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.type == 'solid'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.type== 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">实线</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.type = 'dashed'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.type == 'dashed'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.type == 'dashed'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">虚线</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">边框颜色</div>
			<el-color-picker size="mini" style="height: 34px;width: 34px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.color"></el-color-picker>
			<el-input size="mini" style="height: 34px;width: 82px;" disabled
				:value="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.color"></el-input>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.borderSize" style="margin-top: 10px;">
				<div>线条大小</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSizeTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.borderSize[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSizeTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.borderSize[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSizeTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.borderSize[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSizeTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.borderSize[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerSizeAllTit2 = !borderContainerSizeAllTit2"
							:style="{color:borderContainerSizeAllTit2?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div style="margin-top: 10px;" v-if="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.borderRadius">
				<div>边框圆角</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadiusTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.borderRadius[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左上</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadiusTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.borderRadius[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右上</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadiusTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.borderRadius[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top:2px;">右下</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadiusTit2($event,selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border)"
							v-model="selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Border.borderRadius[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左下</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerRadiusAllTit2 = !borderContainerRadiusAllTit2"
							:style="{color:borderContainerRadiusAllTit2?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div> 
		<el-dialog :modal="false" custom-class="select-imgs" title="文件管理器" :visible.sync="dialogVisibleImgs" width="80%"
			:before-close="()=>{dialogVisibleImgs = false}">
			<select-img style="height: 70vh" @confirmImg="confirmSelectImg($event,'dialogVisibleImgs')"
				v-if="dialogVisibleImgs"></select-img>
		</el-dialog>
	</div>
</template>

<script>
	import selectPage from '../cpm/selectPage.vue'
	import wmInputNumber from '../components/inputNumber.vue'
	import selectImg from '../components/selectImg.vue'
	export default {
		components: {
			wmInputNumber,
			selectImg,
			selectPage
		},
		props: {
			all_setting: {
				type: Array,
				default: []
			},
			goodsData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			fontList: {
				type: Array,
				default: []
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
		},
		data() {
			return {
				marginAllTit2: true,
				paddingAllTit2: true,
				borderContainerRadiusAllTit2: true,
				borderContainerSizeAllTit2: true,

				marginAllTit1: true,
				paddingAllTit1: true,
				borderContainerRadiusAllTit1: true,
				borderContainerSizeAllTit1: true,
				imgsIndex: 0,
				paddingAll: true,
				borderContainerSizeAll: true,
				borderContainerRadiusAll: true,
				dialogVisibleImgs: false
			}
		},
		computed: {
			fontFamilyName: function() {
				if (this.all_setting.length > 0) {
					return this.all_setting[0].tabList[1].config.setfontFamily.name
				} else {
					return ''
				}
			}
		},
		mounted() {
			
			if(!this.selectdItem.compontChildren[0].layoutConfig.img.isScale) {
				this.$set(this.selectdItem.compontChildren[0].layoutConfig.img,'isScale','no')
			}
			
			
			if(!this.selectdItem.compontChildren[0].layoutConfig.img.mode) {
				this.$set(this.selectdItem.compontChildren[0].layoutConfig.img,'mode','cover')
			}
			if(!this.selectdItem.compontChildren[0].layoutConfig.img.typesetting) {
				this.$set(this.selectdItem.compontChildren[0].layoutConfig.img,'typesetting','default')
			}
			
			console.log('selectdItem.compontChildren[0].data',this.selectdItem.compontChildren[0].data)
			
			if(!this.selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Family){
				this.selectdItem.compontChildren[0].layoutConfig.img.tit.tit1Family = this.fontFamilyName
			}
			
			if(!this.selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Family){
				this.selectdItem.compontChildren[0].layoutConfig.img.tit.tit2Family = this.fontFamilyName
			}
			
			
			this.$forceUpdate()
		},
		methods: {
			marginSetTit2(e, item) {
				if (this.marginAllTit2) {
					item.tit2Margin = []
					item.tit2Margin.push(e.target.value)
					item.tit2Margin.push(e.target.value)
					item.tit2Margin.push(e.target.value)
					item.tit2Margin.push(e.target.value)
				}
			},
			paddingSetTit2(e, item) {
				if (this.paddingAllTit2) {
					item.tit2Padding = []
					item.tit2Padding.push(e.target.value)
					item.tit2Padding.push(e.target.value)
					item.tit2Padding.push(e.target.value)
					item.tit2Padding.push(e.target.value)
				}
			},


			marginSetTit1(e, item) {
				if (this.marginAllTit1) {
					item.tit1Margin = []
					item.tit1Margin.push(e.target.value)
					item.tit1Margin.push(e.target.value)
					item.tit1Margin.push(e.target.value)
					item.tit1Margin.push(e.target.value)
				}
			},
			paddingSetTit1(e, item) {
				if (this.paddingAllTit1) {
					item.tit1Padding = []
					item.tit1Padding.push(e.target.value)
					item.tit1Padding.push(e.target.value)
					item.tit1Padding.push(e.target.value)
					item.tit1Padding.push(e.target.value)
				}
				this.$forceUpdate()
			},
			paddingSet(e) {
				if (this.paddingAll) {
					this.selectdItem.compontChildren[0].layoutConfig.img.padding = []
					this.selectdItem.compontChildren[0].layoutConfig.img.padding.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.img.padding.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.img.padding.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.img.padding.push(e.target.value)
				}
			},

			changeContainerSizeTit2(e, item) {
				if (this.borderContainerSizeAllTit2) {
					item.borderSize = []
					item.borderSize.push(e.target.value)
					item.borderSize.push(e.target.value)
					item.borderSize.push(e.target.value)
					item.borderSize.push(e.target.value)
				}
			},

			changeContainerSizeTit1(e, item) {
				if (this.borderContainerSizeAllTit1) {
					item.borderSize = []
					item.borderSize.push(e.target.value)
					item.borderSize.push(e.target.value)
					item.borderSize.push(e.target.value)
					item.borderSize.push(e.target.value)
				}
			},

			changeContainerSize(e) {
				if (this.borderContainerSizeAll) {
					this.selectdItem.compontChildren[0].layoutConfig.img.border.borderSize = []
					this.selectdItem.compontChildren[0].layoutConfig.img.border.borderSize.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.img.border.borderSize.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.img.border.borderSize.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.img.border.borderSize.push(e.target.value)
				}
			},

			changeContainerBorderRadiusTit2(e, item) {
				if (this.borderContainerRadiusAllTit2) {
					item.borderRadius = []
					item.borderRadius.push(e.target.value)
					item.borderRadius.push(e.target.value)
					item.borderRadius.push(e.target.value)
					item.borderRadius.push(e.target.value)
				}
			},


			changeContainerBorderRadiusTit1(e, item) {
				if (this.borderContainerRadiusAllTit1) {
					item.borderRadius = []
					item.borderRadius.push(e.target.value)
					item.borderRadius.push(e.target.value)
					item.borderRadius.push(e.target.value)
					item.borderRadius.push(e.target.value)
				}
			},
			changeContainerBorderRadius(e) {
				if (this.borderContainerRadiusAll) {
					this.selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius = []
					this.selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.img.border.borderRadius.push(e.target.value)
				}
			},
			changeValue(e) {
				if (this.equipment == 'pc') {
					this.selectdItem.compontChildren[0].layoutConfig.img.pcNum = e
				} else {
					this.selectdItem.compontChildren[0].layoutConfig.img.phoneNum = e
				}
			},
			deleteImgs(index) {
				this.selectdItem.compontChildren[0].data.img.list.splice(index, 1)

				let ik = -1
				this.selectdItem.compontChildren[0].data.img.list.forEach(e => {
					if (e.url == '') {
						ik = 1
					}
				})
				if (ik == -1) {
					this.selectdItem.compontChildren[0].data.img.list.push({
						url: "",
						link: {},
						tit1: "",
						tit2: "",
					})
				}
			},
			confirmSelectImg(e) {
				console.log('confirmSelectImg', e)
				let isReplace = false
				if(this.selectdItem.compontChildren[0].data.img.list[this.imgsIndex].url != ''){
					isReplace = true
				}
				this.selectdItem.compontChildren[0].data.img.list[this.imgsIndex].url = e.url
				
				if(isReplace) {
					this.dialogVisibleImgs = false
				}else{
					this.selectdItem.compontChildren[0].data.img.list.push({
						url: "",
						link: {},
						tit1: "",
						tit1Size: 12,
						tit1Family: "",
						tit1Color: "",
						tit1HoverColor: "",
						tit1InImg: true,
						tit1Position: "center", // left right top bottom
						tit1Padding: [0, 0, 0, 0],
						tit1Margin: [0, 0, 0, 0],
						tit1Bg: {
							type: "1",
							// 纯色
							color: "",
							// 渐变
							gradientColor: ""
						},
						tit1Border: {
							borderRadius: [0, 0, 0, 0],
							borderSize: [0, 0, 0, 0],
							radius: 0,
							type: "solid",
							px: 0,
							color: "#fff"
						},
						tit2: "",
						tit2Size: 12,
						tit2Family: "",
						tit2Color: "",
						tit2HoverColor: "",
						tit2InImg: true,
						tit2Position: "center", // left right top bottom
						tit2Padding: [0, 0, 0, 0],
						tit2Margin: [0, 0, 0, 0],
						tit2Bg: {
							type: "1",
							// 纯色
							color: "",
							// 渐变
							gradientColor: ""
						},
						tit2Border: {
							borderRadius: [0, 0, 0, 0],
							borderSize: [0, 0, 0, 0],
							radius: 0,
							type: "solid",
							px: 0,
							color: "#fff"
						}
					})
				}


				

				let index = -1
				this.selectdItem.compontChildren[0].data.img.list.forEach(e => {
					if (e.url == '') {
						index = 1
					}
				})
				if (index == -1) {
					this.selectdItem.compontChildren[0].data.img.list.push({
						url: "",
						link: {},
						tit1: "",
						tit1Size: 12,
						tit1Family: "",
						tit1Color: "",
						tit1HoverColor: "",
						tit1InImg: true,
						tit1Position: "center", // left right top bottom
						tit1Padding: [0, 0, 0, 0],
						tit1Margin: [0, 0, 0, 0],
						tit1Bg: {
							type: "1",
							// 纯色
							color: "",
							// 渐变
							gradientColor: ""
						},
						tit1Border: {
							borderRadius: [0, 0, 0, 0],
							borderSize: [0, 0, 0, 0],
							radius: 0,
							type: "solid",
							px: 0,
							color: "#fff"
						},
						tit2: "",
						tit2Size: 12,
						tit2Family: "",
						tit2Color: "",
						tit2HoverColor: "",
						tit2InImg: true,
						tit2Position: "center", // left right top bottom
						tit2Padding: [0, 0, 0, 0],
						tit2Margin: [0, 0, 0, 0],
						tit2Bg: {
							type: "1",
							// 纯色
							color: "",
							// 渐变
							gradientColor: ""
						},
						tit2Border: {
							borderRadius: [0, 0, 0, 0],
							borderSize: [0, 0, 0, 0],
							radius: 0,
							type: "solid",
							px: 0,
							color: "#fff"
						}
					})
				}
				this.dialogVisibleImgs = false
			}
		}
	}
</script>

<style scoped lang="scss">
	.item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 6px;
	}

	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}

	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;
	}
</style>